export enum Role {
  Gestor = "Gestor de Casos",
  Administrador = "Administrador",
  Enfermera = "Enfermera",
  User = "User",
  GestorCasos ="Gestor",
  GestorJavesalud = "Gestor Javesalud",
  Client = 'Client'
}
